import React from 'react'

import { Header } from './header'
import { Footer } from './footer'

type Props = {
  children: React.ReactNode
  location?: {
    pathname?: string
    hash?: string
  }
}

export function SiteLayout({ children, location }: Props) {
  React.useEffect(() => {
    if (typeof window === 'undefined') return

    const scrollToHashOrTop = () => {
      const hash = location?.hash ?? ''
      if (hash) {
        const id = decodeURIComponent(hash.replace('#', ''))
        const el = document.getElementById(id)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
          return
        }
      }

      window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const raf = requestAnimationFrame(scrollToHashOrTop)
    return () => cancelAnimationFrame(raf)
  }, [location?.pathname, location?.hash])

  return (
    <div className="min-h-screen bg-body text-text">
      <Header />
      <main className="flex-1 pt-16">{children}</main>
      <Footer />
    </div>
  )
}

